import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface SpinnerProps {
  color?: any; // Optional prop: color
  size?: string;  // Optional prop: size
  style?: any;
}

export default class Spinner extends Component<SpinnerProps> {
  render() {
    const { color = 'inherit', size = '2rem', style } = this.props;

    return (
      <div
        className={!style ? 'spinnerCircle' : ''}
        style={style}
      >
        <CircularProgress color={color} size={size} />
      </div>
    );
  }
}
